import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useStore } from 'hooks'
import { BrandsStore } from 'stores/brands'

import BrandDetailContainer from './BrandDetailContainer'
import { THEME, mapMediaDocToVideojsObject } from 'utils'
import MediaQuery from 'react-responsive'

import Twitter from 'icons/Twitter'
import Instagram from 'icons/Instagram'
import TikTok from 'icons/TikTok'
import VideoPlayerLite from 'components/VideoPlayerLite'

const BrandDetailAbout = () => {
  const brandsStore = useStore(BrandsStore)
  const brand = brandsStore.current

  const aboutVideoSource = useMemo(
    () => (brandsStore.current?.sizzle?.video ? mapMediaDocToVideojsObject(brandsStore.current.sizzle.video) : null),
    [brandsStore.current]
  )
  return (
    <BrandDetailContainer>
      <div className='aboutWrapper'>
        <h3 className='aboutTitle'>About {brand.name}</h3>
        <section className='aboutContent'>
          {aboutVideoSource && <VideoPlayerLite videoSource={aboutVideoSource} />}
          <p>{brand.about}</p>
        </section>
        <MediaQuery maxWidth={THEME.BREAKPOINTS.SM - 1}>
          <h3 className='subheading'>Hosts</h3>
          {brand.authors.map((author) => (
            <div className='author' key={author.name}>
              <img className='avatar' src={author.avatar} alt={author.name} />
              <div className='name'>{author.name}</div>
            </div>
          ))}
          {(brand.social.twitter || brand.social.instagram || brand.social.tiktok) && (
            <h3 className='subheading'>Follow Us</h3>
          )}
          {brand.social.twitter ? (
            <a className='socialLink' target='_blank' rel='noreferrer noopener' href={brand.social.twitter.url}>
              <Twitter color='#222' height='auto' width='3rem' />
              <div className='socialDetail'>
                <h3>Twitter</h3>
                <p className='socialHandle'>@{brand.social.twitter.handle}</p>
              </div>
            </a>
          ) : null}
          {brand.social.instagram ? (
            <a className='socialLink' target='_blank' rel='noreferrer noopener' href={brand.social.instagram.url}>
              <Instagram color='#222' height='auto' width='3rem' />
              <div className='socialDetail'>
                <h3>Instagram</h3>
                <p className='socialHandle'>@{brand.social.instagram.handle}</p>
              </div>
            </a>
          ) : null}
          {brand.social.tiktok ? (
            <a className='socialLink' target='_blank' rel='noreferrer noopener' href={brand.social.tiktok.url}>
              <TikTok height='auto' width='3rem' fill='#222' />
              <div className='socialDetail'>
                <h3>TikTok</h3>
                <p className='socialHandle'>@{brand.social.tiktok.handle}</p>
              </div>
            </a>
          ) : null}
        </MediaQuery>
      </div>
      <style jsx>{`
        .aboutWrapper {
          background: #fff;
        }
        .aboutTitle {
          font-family: ${THEME.FONTS.BEBAS};
          font-size: 1.875rem;
          font-weight: 600;
          text-transform: uppercase;
          color: ${THEME.COLORS.SECONDARY};
          line-height: 1.2;
          padding: 0.75rem 1.125rem;
          margin: 0;
        }
        .aboutContent {
          padding: 1rem;
        }
        .aboutContent p {
          font-size: 1rem;
          margin-top: 1rem;
        }
        .video-js {
          margin-bottom: 20px;
        }
        .author {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          padding: 0.25rem 1rem;
        }
        .avatar {
          height: 48px;
          width: 48px;
          border-radius: 50%;
          margin-right: 16px;
        }
        .name {
          font-weight: bold;
          font-size: 16px;
        }
        .socialLink {
          display: flex;
          align-items: center;
          height: 4rem;
          color: #222;
          padding: 0.5rem 1rem;
          margin-bottom: 1rem;
        }
        .socialDetail {
          height: 100%;
          padding: 0.25rem 1rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .socialDetail h3 {
          margin: 0;
          line-height: 1;
          height: 1rem;
        }
        .socialDetail p {
          margin: 0;
          line-height: 1;
          height: 1rem;
          font-size: 0.75rem;
          color: #a1a1a1;
          font-weight: 900;
        }
        .subheading {
          padding: 1rem 1rem 0.4rem;
          margin: 0;
          font-size: 14px;
          border-bottom: 1px solid #f1f1f1;
        }
      `}</style>
    </BrandDetailContainer>
  )
}

export default observer(BrandDetailAbout)
